import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_PRODUCT, UPDATE_PRODUCT_STATUS, ADD_PRODUCT, EDIT_PRODUCT, DELETE_PRODUCT, UPDATE_PRODUCT_ORDER_STATUS } from "../Constants";
import { defaultHeaders } from "../Constants/DefaultHeaders";
import { logout } from "../../utils";
import { GetProductSuccess, GetProductFailure, UpdateProductStatusSuccess, UpdateProductStatusFailure, AddProductSuccess, AddProductFailure, EditProductSuccess, EditProductFailure, DeleteProductSuccess, DeleteProductFailure, UpdateProductOrderStatusSuccess, UpdateProductOrderStatusFailure } from "../Actions/ProductAction";

function* getProductRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/products?user_type=${actions.payload.user_type}&status=${actions.payload.status}`, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(GetProductSuccess(res.data));
    } else {
      yield put(GetProductFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetProductFailure(e));
  }
}

function* productStatusRequest(actions) {
  const body = {
    id: actions.payload.id,
    status: actions.payload.status,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_product_status`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateProductStatusSuccess(res.data));
    } else yield put(UpdateProductStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateProductStatusFailure(e));
  }
}

function* addProductRequest(actions) {
  const body = {
    title: actions.payload.title,
    description: actions.payload.description,
    apr: actions.payload.apr,
    apy: actions.payload.apy,
    user_type: actions.payload.user_type,
    est_minutes: actions.payload.est_minutes,
    type: actions.payload.type,
    information: actions.payload.information,
    app_android_url: actions.payload.app_android_url,
    app_ios_url: actions.payload.app_ios_url,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/add_product`, body, { headers: defaultHeaders() });
    if (res.status === 200) {
      yield put(AddProductSuccess(res.data));
    } else {
      yield put(AddProductFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(AddProductFailure(e));
  }
}

function* editProductRequest(actions) {
  const body = {
    id: actions.payload.id,
    title: actions.payload.title,
    description: actions.payload.description,
    apr: actions.payload.apr,
    apy: actions.payload.apy,
    user_type: actions.payload.user_type,
    est_minutes: actions.payload.est_minutes,
    type: actions.payload.type,
    information: actions.payload.information,
    app_android_url: actions.payload.app_android_url,
    app_ios_url: actions.payload.app_ios_url,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/edit_product`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(EditProductSuccess(res.data));
    } else {
      yield put(EditProductFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(EditProductFailure(e));
  }
}

function* deleteProductRequest(actions) {
  try {
    const res = yield axios.delete(`${process.env.REACT_APP_API_URL}api/admin/product/${actions.payload}`, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(DeleteProductSuccess(res.data));
    } else {
      yield put(DeleteProductFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(DeleteProductFailure(e));
  }
}

function* productOrderStatusRequest(actions) {
  let data = [];
  actions.payload.map((arr) => {
    data.push(arr);
  });
  const body = {
    data,
  };
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/change_product_order_number`, body, { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } });
    if (res.status === 200) {
      yield put(UpdateProductOrderStatusSuccess(res.data));
    } else yield put(UpdateProductOrderStatusFailure(res));
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(UpdateProductOrderStatusFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_PRODUCT, getProductRequest);
  yield takeLatest(UPDATE_PRODUCT_STATUS, productStatusRequest);
  yield takeLatest(EDIT_PRODUCT, editProductRequest);
  yield takeLatest(DELETE_PRODUCT, deleteProductRequest);
  yield takeLatest(ADD_PRODUCT, addProductRequest);
  yield takeLatest(UPDATE_PRODUCT_ORDER_STATUS, productOrderStatusRequest);
}

export default function* ProductSaga() {
  yield all([actionWatcher()]);
}
